export const QUALITY_ID_PENNY = 22390;

export const EXPLICITLY_FILTERABLE_QUALITY_IDS = [
  142591,
  144845,
  144846,
];

export const FILTERABLE_CATEGORY_NAMES = [
  'BasicAbility',
  'SidebarAbility',
  'Menace',
  'Skills',
];

export const UNFILTERABLE_ENHANCEMENT_QUALITY_IDS = [
  18736,
  18737,
  18738,
];

export const EXCLUDED_CATEGORY_NAMES = [
  'Constant Companion',
];

export const EXCLUDED_QUALITY_IDS = [
  QUALITY_ID_PENNY,
];

export const EQUIP_HIGHEST_QUALITY_FILTER_IDS = [
  209,
  210,
  211,
  212,
  950,
  957,
  958,
  140826,
  140830,
  140873,
  140896,
  140897,
  140969,
  140998,
  142291,
  142591,
  144818,
  144845,
  144846,
];
